<!-- 设备编辑 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-form ref="editForm" :model="device" label-width="100px" :rules="validateRules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="设备编号" prop="deviceCode">
            <el-input type="text" v-model.trim="device.deviceCode" maxlength="15"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备名称" prop="deviceName">
            <el-input type="text" v-model.trim="device.deviceName" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备类型" prop="deviceType">
            <code-select v-model="device.deviceType" code-type="DEVICE_TYPE"></code-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="软件版本" prop="softVersion">
            <el-input type="text" v-model.trim="device.softVersion" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机房类型" prop="roomType">
            <code-select v-model="device.roomType" code-type="ROOM_TYPE"></code-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="空调联动" prop="valid">
            <el-switch v-model="device.acUnion"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="所属单位" prop="compId">
        <comp-select v-model="device.compId" :remote="false" @select="compChange"></comp-select>
      </el-form-item>
      <el-form-item label="所属区域" prop="townCode">
        <area-cascader v-model="areaCodes" @change="areaChange"></area-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="deviceName">
        <el-input type="text" v-model.trim="device.address" maxlength="200"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="进风风机" prop="inFanCount">
            <el-input-number v-model="device.inFanCount" :min="1" :max="100" :precision="0"></el-input-number>&nbsp;台
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出风风机" prop="outFanCount">
            <el-input-number v-model="device.outFanCount" :min="1" :max="100" :precision="0"></el-input-number>&nbsp;台
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="device.acUnion">
          <el-form-item label="空调数量" prop="acCount">
            <el-input-number v-model="device.acCount" :min="1" :max="100" :precision="0"></el-input-number>&nbsp;台
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="device.acUnion">
          <el-form-item label="空调总功率" prop="acPower">
            <el-input-number v-model="device.acPower" :min="1" :precision="0"></el-input-number>&nbsp;W
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="经纬度" prop="lng">
            <div class="display-flex">
              <el-input-number v-model="device.lng" :controls="false" placeholder="经度" style="width: 150px"></el-input-number>
              <span>，</span>
              <el-input-number v-model="device.lat" :controls="false" placeholder="纬度" style="width: 150px"></el-input-number>
              <el-button type="text" @click="mapVisible = true"><i class="fa fa-map-marker" style="font-size: 24px"></i></el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否启用" prop="valid">
            <el-switch v-model="device.valid"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
      <el-button type="primary" @click="save" icon="fa fa-save">保存</el-button>
    </template>

    <map-choose-dialog title="位置选择" :visible.sync="mapVisible"
                       append-to-body
                       v-if="mapVisible" width="90vw"
                       :lng="device.lng"
                       :lat="device.lat"
                       :editable="true"
                       @change="onPositionChange"
                       @close="mapVisible = false"></map-choose-dialog>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import CodeRadioGroup from "@/components/base/CodeRadioGroup";
import CompSelect from "@/components/base/CompSelect";
import MapChooseDialog from "@/components/base/MapChooseDialog";
import CodeSelect from "@/components/base/CodeSelect.vue";
import AreaCascader from "@/components/base/AreaCascader.vue";

export default {
  components: {AreaCascader, CodeSelect, MapChooseDialog, CompSelect, CodeRadioGroup},
  extends: BaseVue,
  props: {
    device: {
      required: true
    }
  },
  data() {
    return {
      mapVisible: false,
      validateRules: {
        deviceCode: [{required:true, message:'设备编码不能为空', trigger: 'blur'}],
        deviceType: [{required:true, message:'设备类型不能为空', trigger: 'change'}],
        compId: [{required:true, message:'所属单位不能为空', trigger: 'blur'}],
        // townCode: [{required:true, message:'所属区域不能为空', trigger: 'change'}],
        inFanCount: [{required:true, message:'进风风机数量不能为空', trigger: 'blur'}],
        outFanCount: [{required:true, message:'出风风机数量不能为空', trigger: 'blur'}],
        acCount: [{required:true, message:'空调数量不能为空', trigger: 'blur'}],
        acPower: [{required:true, message:'空调总功率不能为空', trigger: 'blur'}],
        lng: [{trigger: 'blur', validator:(rule,value,callback)=>{
            if(!this.device.lng || !this.device.lat) {
              callback("经纬度不能为空");
              return;
            }
            callback();
        }}]
      },
      areaCodes: []
    }
  },
  created() {
    this.resetArea();
  },
  methods: {
    close(){
      this.$emit("close");
    },
    save(){
      let editForm = this.$refs["editForm"];
      editForm.validate((yes)=>{
        if(yes){
          this.loading = true;
          this.postForm("/device/saveDevice", this.device, true).then(dr => {
            this.$emit("save", dr.bean);
          }).finally(()=>{
            this.loading = false;
          });
        }
      })
    },
    onPositionChange(point) {
      this.device.lng = point.lng;
      this.device.lat = point.lat;
      this.mapVisible = false;
    },
    compChange(comp) {
      if(comp) {
        this.device.provCode = comp.provCode;
        this.device.cityCode = comp.cityCode;
        this.device.townCode = comp.townCode;
        this.resetArea();
      }
    },
    areaChange(areaCodes) {
      if(areaCodes.length > 0) {
        this.device.provCode = areaCodes[0];
        if(areaCodes.length > 1) {
          this.device.cityCode = areaCodes[1];
        }
        if(areaCodes.length > 2) {
          this.device.townCode = areaCodes[2];
        }
      } else {
        this.device.provCode = null;
        this.device.cityCode = null;
        this.device.townCode = null;
      }
    },
    resetArea() {
      this.areaCodes = [];
      if(this.device.provCode) {
        this.areaCodes.push(this.device.provCode);
      }
      if(this.device.cityCode) {
        this.areaCodes.push(this.device.cityCode);
      }
      if(this.device.townCode) {
        this.areaCodes.push(this.device.townCode);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.display-flex{
  display: flex;
  align-items: center;
  .el-button{
    padding: 5px 20px;
  }
}
</style>